import React from "react";
import aboutusmainnewimg from "../images/aboutusmainnewimg.jpeg";
import ourmission from "../images/ourmission.png";
import whoweare from "../images/whoweare.png";
import {
  FiBookOpen,
  FiBarChart2,
  FiCalendar,
  FiClock,
  FiEdit3,
  FiCreditCard,
} from "react-icons/fi";
function Aboutus() {
  return (
    <>
      <section class="topaboutus">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-12 col-md-7 col-lg-7 mb-3 mb-md-0">
              <div class="main-heading text-left mobile-pt-top mb-3">
                <h2> About Ultimate Driver</h2>
              </div>
              <div class="youtrustedin">
                <p>
                  Established in 1993, we are one of the largest driver training
                  organizations with over 22 locations in Ontario and
                  continuously growing. Our technology friendly approach towards
                  driver education has made us the first choice of today's
                  generation. We offer a complete range of in-person, online or
                  e-learning courses for our students and build customized
                  programs that suit the specific needs and schedules for all.
                </p>
              </div>
              <p class="mainaboutextbottomline">
                Our online applications provide full control in the hands of our
                students.
              </p>
            </div>
            <div class="col-12 col-md-5 col-lg-4">
              <img class="mainabouttopimg" src={aboutusmainnewimg} />
            </div>
          </div>
          <div class="mainmissionvisionbox mt-3 mt-md-5 ">
            <div class="row justify-content-between">
              <div class="col-md-5  mb-3 mb-md-0">
                <div class="maindetailsmissionvision">
                  <img src={whoweare} />
                  <h6 class="title">Who We Are</h6>
                  <p class="discription">
                    Ultimate Drivers provides you the opportunity to become a
                    trained and safe driver. We are a Ministry-Approved BDE
                    Course Provider who gives the best learning experience in
                    driver education through E-Learning, in-person, or virtual
                    online classes with a live instructor. You discover learning
                    in safe and expert hands. The courses are designed to meet
                    the peculiar needs of candidates.
                  </p>
                </div>
              </div>
              <div class="col-md-5">
                <div class="maindetailsmissionvision">
                  <img src={ourmission} />
                  <h6 class="title">Our Mission</h6>
                  <p class="discription">
                    Our mission at Ultimate Drivers is to provide our customers
                    with a driving school that they can trust will train
                    responsible and safe drivers of tomorrow. We are determined
                    to provide the highest quality of in-class instructions,
                    in-car driver training and excellent customer service to all
                    our customers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bottomaboutus">
        <div class="container">
          <div>
            <div class="main-heading text-center mobile-pt-top mb-5">
              <h2> What We Provide </h2>
              <p className="w-100">
                Sapiente et quia sit autem. Quos porro deleniti. Optio itaque
                nam dolorum aut ea aperiam cum voluptate quaerat.
              </p>
            </div>
            <div class="gridnew">
             
                <div class="whatweprovidecontantbox">
                  <div className="icons">
                    <FiBookOpen />
                  </div>
                  <p class="title">Training Materials</p>
                </div>
            
              
                <div class="whatweprovidecontantbox">
                  <div className="icons">
                    <FiBarChart2 />
                  </div>
                  <p class="title">Progress Reports</p>
                </div>
            
             
                <div class="whatweprovidecontantbox">
                  <div className="icons">
                    <FiCalendar />
                  </div>
                  <p class="title">
                    Convenient Appointment <br /> System
                  </p>
                </div>
            
              
                <div class="whatweprovidecontantbox">
                  <div className="icons">
                    <FiClock />
                  </div>
                  <p class="title">
                    Flexible timings for in-class <br /> and in-car Courses
                  </p>
                </div>
              
              
                <div class="whatweprovidecontantbox">
                  <div className="icons">
                    <FiEdit3 />
                  </div>
                  <p class="title">
                    Free Revision for in-class and <br /> online courses
                  </p>
                </div>
              
              
                <div class="whatweprovidecontantbox">
                   <div className="icons">
                  <FiCreditCard />
                  </div>
                  <p class="title">Easy Payment plans</p>
                </div>
              
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Aboutus;
